module.exports = __webpack_public_path__ + "static/img/native.e84d4ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/native.png
// module id = ilPp
// module chunks = 1 3